require('./general');
require('./video');



// WEBPACK FOOTER //
// ./resources/assets/js/regular/index.js